<!-- 新闻卡片 -->
<template>
  <div :class="[['news'], 'news-' + size]" @click="gotoPage(content)">
    <div :class="[['news-date'], 'news-date-' + size]">
      <div class="news-date-title">{{ content.addDate.substring(8, 10) }}</div>
      <div class="news-date-desc">{{ content.addDate.substring(0, 7) }}</div>
    </div>
    <div :class="[['news-line'], 'news-line-' + size]"></div>
    <div :class="[['news-desc'], 'news-desc-' + size]">
      <div class="news-desc-title">
        {{ content.title || "" }}
      </div>
      <div class="news-desc-desc">
        {{ doText }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  props: {
    size: String,
    content: {
      type: Object,
      default: () => {
        return {
          title: "水利部召开加强高校计划用水管理工作视频会议",
          body: " 5月30日，水利部召开加强高校计划用水管理工作视频会议，要求深入贯彻落实习近平总书记重要指示批示精神，加快推进节水型高校建设，严格计划用水管理和用水定额约……",
        };
      },
    },
  },
  components: {},
  name: "NewsCard",
  setup(props, ctx) {
    const router = useRouter();
    function gotoPage(content: any) {
      router.push({ name: "newsDesc", query: content });
    }
    // console.log(props.content.body.replace(/<\/?[^>]+(>|$)/g, ""));
    const doText = computed(() => {
      return props.content.body.replace(/<\/?[^>]+(>|$)/g, "");
    });
    return { gotoPage, doText };
  },
});
</script>
<style scoped lang="scss">
.news-m:hover {
  background-color: #fbfbfb;
}
.news-l:hover {
  background-color: #fbfbfb;
}
.news-s:hover {
  background-color: #ebf2fa;
  .news-desc-desc {
    color: #187ccd;
  }
}
.news {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  &-m {
    width: 694px;
    height: 140px;
  }
  &-s {
    width: 764px;
    height: 108px;
    background-color: #f2f2f2;
  }
  &-l {
    width: 1399px;
    height: 166px;
    border-bottom: 1px solid #eeeeee;
  }
  &-date {
    text-align: right;
    &-m {
      margin-right: 21px;
      margin-left: 20px;
    }
    &-s {
      margin-right: 21px;
      margin-left: 24px;
    }
    &-l {
      margin-right: 21px;
      margin-left: 32px;
    }
    &-title {
      font-weight: 400;
      font-size: 28px;
      color: #000000;
      line-height: 33px;
    }
    &-desc {
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      line-height: 16px;
    }
  }
  &-line {
    height: 74px;
    width: 1px;
    background-color: #f2f2f2;
    &-s &-l {
      background-color: #dddddd;
    }
  }
  &-desc {
    text-align: left;
    &-m {
      margin-left: 22px;
      width: 555px;
    }
    &-s {
      margin-left: 22px;
      width: 617px;
    }
    &-l {
      margin-left: 22px;
      width: 1236px;
    }
    &-title {
      font-weight: 400;
      font-size: 18px;
      color: #000000;
      line-height: 21px;
      margin-bottom: 8px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: justify;
      word-break: break-all;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }
    &-desc {
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 24px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: justify;
      word-break: break-all;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
}
</style>
